var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'shareModal')?_c('ShareModal',{attrs:{"name":_vm.props.name,"shareType":_vm.props.shareType,"entityId":_vm.props.entityId,"title":_vm.props.title,"sharingAccountId":_vm.props.sharingAccountId,"organizationId":_vm.props.organizationId,"filters":_vm.props.filters},on:{"hideModal":_vm.hideModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }